module.exports = {"610202001":"七一路街道","610202002":"红旗街道","610202003":"桃园街道","610202004":"青年路街道","610202005":"王家河街道","610202006":"王益街道","610202100":"黄堡镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610202.json
// module id = 2790
// module chunks = 0